class CertificateCertkey {
    get type() {
        return this._type;
    }

    get disk() {
        return this._disk;
    }

    get path() {
        return this._path;
    }

    get name() {
        return this._name;
    }

    get serialNumber() {
        return this._serialNumber;
    }

    get validFromDate() {
        return this._validFromDate;
    }

    get validEndDate() {
        return this._validEndDate;
    }

    get innNumber() {
        return this._innNumber;
    }

    get companyName() {
        return this._companyName;
    }

    get issuedPerson() {
        return this._issuedPerson;
    }

    get alias() {
        return this._alias;
    }

    constructor(eimzoCertificateObject) {
        const subjectSeparatedValues = eimzoCertificateObject.subjectName.split(',');
        let innNumber = this._getValueFromSeparatedValuesArray(subjectSeparatedValues, 'INITIALS', null);
        if (innNumber === null) {
            innNumber = this._getValueFromSeparatedValuesArray(subjectSeparatedValues, 'INN', null);
            if (innNumber === null)
                innNumber = this._getValueFromSeparatedValuesArray(subjectSeparatedValues, 'UID', '');
        }

        this._type = 'cer';
        this._disk = eimzoCertificateObject.disk;
        this._path = eimzoCertificateObject.path;
        this._name = eimzoCertificateObject.name;
        this._serialNumber = eimzoCertificateObject.serialNumber;
        this._validFromDate = new Date(eimzoCertificateObject.validFrom);
        this._validEndDate = new Date(eimzoCertificateObject.validTo);
        this._innNumber = innNumber;
        this._companyName = this._getValueFromSeparatedValuesArray(subjectSeparatedValues, 'O', '');
        this._issuedPerson = this._getValueFromSeparatedValuesArray(subjectSeparatedValues, 'CN', '');
        this._alias = null;
    }

    _getValueFromSeparatedValuesArray(values, key, defaultValue) {
        const keyInUpperCase = `${key.toUpperCase()}=`;

        for (let i = 0; i < values.length; i++) {
            const value =  values[i];
            if (value.length >= keyInUpperCase.length)
                if (value.substr(0, keyInUpperCase.length).toUpperCase() === keyInUpperCase)
                    return value.substr(keyInUpperCase.length);
        }

        if (typeof (defaultValue) === 'undefined')
            defaultValue = null;

        return defaultValue;
    }
}

class CertificatePfx {
    get type() {
        return this._type;
    }

    get disk() {
        return this._disk;
    }

    get path() {
        return this._path;
    }

    get name() {
        return this._name;
    }

    get serialNumber() {
        return this._serialNumber;
    }

    get validFromDate() {
        return this._validFromDate;
    }

    get validEndDate() {
        return this._validEndDate;
    }

    get innNumber() {
        return this._innNumber;
    }

    get companyName() {
        return this._companyName;
    }

    get issuedPerson() {
        return this._issuedPerson;
    }

    get alias() {
        return this._alias;
    }

    constructor(eimzoCertificateObject) {
        const aliasValues = eimzoCertificateObject.alias.split(',');
        let innNumber = this._getValueFromSeparatedValuesArray(aliasValues, '1.2.860.3.16.1.1', null);
        if (innNumber === null) {
            innNumber = this._getValueFromSeparatedValuesArray(aliasValues, 'INN', null);
            if (innNumber === null)
                innNumber = this._getValueFromSeparatedValuesArray(aliasValues, 'UID', '');
        }

        const todaysLastMoment = new Date();
        todaysLastMoment.setHours(23);
        todaysLastMoment.setMinutes(59);
        todaysLastMoment.setSeconds(59);
        todaysLastMoment.setMilliseconds(999);

        let validFrom = this._getValueFromSeparatedValuesArray(aliasValues, 'validfrom', null);
        if (validFrom === null || validFrom === undefined)
            validFrom = todaysLastMoment;
        else
            validFrom = new Date(validFrom.split('.').join('-'));

        let validTo = this._getValueFromSeparatedValuesArray(aliasValues, 'validto', null);
        if (validTo === null || validTo === undefined)
            validTo = todaysLastMoment;
        else
            validTo = new Date(validTo.split('.').join('-'));

        this._type = 'pfx';
        this._disk = eimzoCertificateObject.disk;
        this._path = eimzoCertificateObject.path;
        this._name = eimzoCertificateObject.name;
        this._serialNumber = this._getValueFromSeparatedValuesArray(aliasValues, 'serialnumber', '');
        this._validFromDate = new Date(validFrom);
        this._validEndDate = new Date(validTo);
        this._innNumber = innNumber;
        this._companyName = this._getValueFromSeparatedValuesArray(aliasValues, 'o', '');
        this._issuedPerson = this._getValueFromSeparatedValuesArray(aliasValues, 'cn', '');
        this._alias = eimzoCertificateObject.alias;
    }

    _getValueFromSeparatedValuesArray(values, key, defaultValue) {
        const keyInUpperCase = `${key.toUpperCase()}=`;

        for (let i = 0; i < values.length; i++) {
            const value = values[i];
            if (value.length >= keyInUpperCase.length)
                if (value.substr(0, keyInUpperCase.length).toUpperCase() === keyInUpperCase)
                    return value.substr(keyInUpperCase.length);
        }

        if (typeof (defaultValue) === 'undefined')
            defaultValue = null;

        return defaultValue;
    }
}

class ActiveCertificate {
    constructor(certificate, keyId, activateTime) {
        this._certificate = certificate;
        this._activateTime = activateTime;
        this._keyId = keyId;
    }

    get certificate() {
        return this._certificate;
    }

    get activateTime() {
        return this._activateTime;
    }

    get keyId() {
        return this._keyId;
    }
}

class SignResult {
    _pkcs7;
    _serialNumber;

    constructor(pkcs7, serialNumber) {
        this._pkcs7 = pkcs7;
        this._serialNumber = serialNumber;
    }

    get pkcs7() {
        return this._pkcs7;
    }

    get serialNumber() {
        return this._serialNumber;
    }
}

class Eimzo {
    _settings;
    _helpers;
    _isWebSocketEnabled;
    _isInitialized;
    _certificates;
    _activeCertificates;

    constructor(url, hostname, apiKey) {
        this._settings = {
            url: url,
            hostname: hostname,
            apiKey: apiKey
        };

        let fromCharCode = String.fromCharCode;
        let cb_utob = function (c) {
            if (c.length < 2) {
                let cc = c.charCodeAt(0);
                return cc < 0x80 ? c
                    : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                        + fromCharCode(0x80 | (cc & 0x3f)))
                        : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                            + fromCharCode(0x80 | ((cc >>> 6) & 0x3f))
                            + fromCharCode(0x80 | (cc & 0x3f)));
            } else {
                let cc = 0x10000
                    + (c.charCodeAt(0) - 0xD800) * 0x400
                    + (c.charCodeAt(1) - 0xDC00);
                return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                    + fromCharCode(0x80 | ((cc >>> 6) & 0x3f))
                    + fromCharCode(0x80 | (cc & 0x3f)));
            }
        };
        // eslint-disable-next-line no-control-regex
        let re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
        let utob = function (u) {
            return u.replace(re_utob, cb_utob);
        };
        let _encode = function (u) {
            return btoa(utob(u))
        };
        let base64 = {
            encode: function (u, urisafe) {
                return !urisafe
                    ? _encode(u)
                    : _encode(u).replace(/[+/]/g, function (m0) {
                        return m0 === '+' ? '-' : '_';
                    }).replace(/=/g, '');
            }
        }

        this._helpers = {
            base64: base64
        };

        this._isWebSocketEnabled = !!window.WebSocket;
        this._isInitialized = false;

        this._certificates = [];
        this._activeCertificates = [];

        this._init()
            .then(() => {
                if (this._isInitialized)
                    this._loadCertificates();
            }, () => {
            });
    }

    get certificates() {
        return this._certificates;
    }

    get activeCertificates() {
        return this._activeCertificates;
    }

    activateCertificate(certificate) {
        return new Promise((resolve, reject) => {
            const data = {
                plugin: certificate.type === 'pfx' ? 'pfx' : 'certkey',
                name: 'load_key',
                arguments: [
                    certificate.disk,
                    certificate.path,
                    certificate.name,
                    (certificate.type === 'pfx' ? certificate.alias : certificate.serialNumber)
                ]
            };
            this._makeRequest(data)
                .then((loadKeyResponse) => {
                    let activatedCertificate = null;
                    if (loadKeyResponse.success) {
                        activatedCertificate = new ActiveCertificate(certificate, loadKeyResponse.keyId, new Date());
                        this._activeCertificates.push(activatedCertificate);
                        resolve(activatedCertificate);
                    } else {
                        reject();
                    }
                }, reject);
        });
    }

    activate(certificate) {
        return new Promise((resolve, reject) => {
            const data = {
                plugin: certificate.type === 'pfx' ? 'pfx' : 'certkey',
                name: 'load_key',
                arguments: [
                    certificate.disk,
                    certificate.path,
                    certificate.name,
                    (certificate.type === 'pfx' ? certificate.alias : certificate.serialNumber)
                ]
            };
            this._makeRequest(data)
                .then((loadKeyResponse) => {
                    let activatedCertificate = null;
                    if (loadKeyResponse.success) {
                        activatedCertificate = new ActiveCertificate(certificate, loadKeyResponse.keyId, new Date());
                        this._activeCertificates.push(activatedCertificate);

                        this.createPkcs7('activation', activatedCertificate)
                            .then(() => {
                                resolve(activatedCertificate)
                            }).catch((error) => {
                                reject(error);
                        })
                    } else {
                        reject();
                    }
                }, reject);
        });
    }

    createPkcs7(hashCode, activeCertificate) {
        const hashCodeBase64 = this._helpers.base64.encode(hashCode);

        return new Promise((resolve, reject) => {
            const data = {
                plugin: "pkcs7",
                name: "create_pkcs7",
                arguments: [
                    hashCodeBase64,
                    activeCertificate.keyId,
                    "no"
                ]
            };

            this._makeRequest(data)
                .then((createPkcs7Response) => {
                    if (createPkcs7Response.success) {
                        const signResult = new SignResult(createPkcs7Response.pkcs7_64, createPkcs7Response.signer_serial_number);
                        resolve(signResult);
                    } else {
                        reject();
                    }
                }, reject);
        });
    }

    _init() {
        return new Promise((resolve, reject) => {
            let data = {
                name: 'apikey',
                arguments: [this._settings.hostname, this._settings.apiKey]
            };
            this._makeRequest(data).then((response) => {
                this._isInitialized = response.success;
                resolve();
            }, () => {
                reject();
            });
        });
    }

    _loadDisks() {
        return new Promise((resolve, reject) => {
            this._makeRequest({plugin: "pfx", name: "list_disks"})
                .then((response) => {
                    resolve(response);
                }, reject);
        });
    }

    _loadCertificates() {
        return new Promise((resolve, reject) => {
            this._certificates = [];
            let promises = [];

            this._loadDisks()
                .then((response) => {
                    if (response.success) {
                        for (let diskIndex = 0; diskIndex < response.disks.length; diskIndex++) {
                            // pfx
                            let loadDiskPfxCertificatesPromise = this._makeRequest({
                                plugin: "pfx",
                                name: "list_certificates",
                                arguments: [response.disks[diskIndex]]
                            });

                            promises.push(loadDiskPfxCertificatesPromise);

                            loadDiskPfxCertificatesPromise.then((loadPfxCertificatesResponse) => {
                                for (let pfxCerficiateIndex = 0;
                                     pfxCerficiateIndex < loadPfxCertificatesResponse.certificates.length;
                                     pfxCerficiateIndex++) {
                                    let pfxCertificate = new CertificatePfx(loadPfxCertificatesResponse.certificates[pfxCerficiateIndex]);

                                    this._certificates.push(pfxCertificate);
                                }
                            });


                            // certkey
                            let loadDiskCertkeyCertificatesPromise = this._makeRequest({
                                plugin: "certkey",
                                name: "list_certificates",
                                arguments: [response.disks[diskIndex]]
                            });

                            promises.push(loadDiskCertkeyCertificatesPromise);

                            loadDiskCertkeyCertificatesPromise.then((loadCertkeyCertificatesResponse) => {
                                for (let pfxCerficiateIndex = 0;
                                     pfxCerficiateIndex < loadCertkeyCertificatesResponse.certificates.length;
                                     pfxCerficiateIndex++) {
                                    let certKeyCertificate = new CertificateCertkey(loadCertkeyCertificatesResponse.certificates[pfxCerficiateIndex]);

                                    this._certificates.push(certKeyCertificate);
                                }
                            });
                        }
                    }

                    Promise.all(promises).then(resolve, reject);
                }, reject);
        });
    }

    _makeRequest(data) {
        return new Promise((resolve, reject) => {
            let socket;
            try {
                socket = new WebSocket(this._settings.url);
                socket.onopen = () => {
                    socket.send(JSON.stringify(data));
                };
                socket.onmessage = (event) => {
                    socket.close();
                    let response = JSON.parse(event.data);
                    resolve(response);
                };
                socket.onerror = () => {
                    socket.close();
                    reject();
                };
            } catch (e) {
                reject();
            }
        });
    }
}

import {EIMZO_URL, EIMZO_HOST, EIMZO_API_KEY} from '../settings/eimzo'

export default new Eimzo(EIMZO_URL, EIMZO_HOST, EIMZO_API_KEY);